import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';

import { getPublicSessions } from '../new/session';

const usePublicSessions = classId => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.sessions.active);

  useEffect(() => {
    if (!classId) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request.classId !== classId)) {
      dispatch(getPublicSessions(classId));
    }
  }, [classId, data, dispatch, request, status]);

  if (!classId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }
  return { data: data || [], status, version, entity };
};

export default usePublicSessions;
